export const adgroupFields = [
  'adgroup_name',
  'traffic_channel',
  'clicks',
  'impressions',
  'cost',
  'conversions_value',
  'sessions',
  'bounces',
  'sign_ups',
  'orders',
  'gm',
  'ttv',
  'gm_ar',
  'ttv_ar',
  'first_sale_gm',
  'first_sale_gm_ar',
  'ltle_gm',
  'ltle_gm_ar',
  'lpp_gm',
  'lpp_gm_ar',
  'lpc_gm',
  'lpc_gm_ar',
  'tour_gm',
  'tour_gm_ar',
  'cruise_gm',
  'cruise_gm_ar',
  'experience_gm',
  'experience_gm_ar',
  'luxplus_gm',
  'luxplus_gm_ar',
  'luxplus_new_signups',
  'ltle_orders',
  'lpp_orders',
  'lpc_orders',
  'cash_only_gm',
  'customer_discount',
  'customer_discount_ar',
  'voucher_sales_aud',
  'target_roas_weighted',
  'target_roas_cost',
  'effective_target_roas_weighted',
  'effective_target_roas_cost',
  'search_top_weighted',
  'search_top_impressions',
  'search_absolute_top_weighted',
  'search_absolute_top_impressions',
];

export const dailyFields = [
  'bucket',
  'split_group',
  'clicks',
  'impressions',
  'cost',
  'conversions_value',
  'sessions',
  'bounces',
  'sign_ups',
  'orders',
  'gm',
  'ttv',
  'gm_ar',
  'ttv_ar',
  'first_sale_gm',
  'first_sale_gm_ar',
  'ltle_gm',
  'ltle_gm_ar',
  'lpp_gm',
  'lpp_gm_ar',
  'lpc_gm',
  'lpc_gm_ar',
  'tour_gm',
  'tour_gm_ar',
  'cruise_gm',
  'cruise_gm_ar',
  'experience_gm',
  'experience_gm_ar',
  'luxplus_gm',
  'luxplus_gm_ar',
  'luxplus_new_signups',
  'ltle_orders',
  'lpp_orders',
  'lpc_orders',
  'cash_only_gm',
  'customer_discount',
  'customer_discount_ar',
  'voucher_sales_aud',
  'target_roas_weighted',
  'target_roas_cost',
  'effective_target_roas_weighted',
  'effective_target_roas_cost',
  'search_top_weighted',
  'search_top_impressions',
  'search_absolute_top_weighted',
  'search_absolute_top_impressions',
];
export const salesDailyFields = [
  'bucket',
  'split_group',
  'gm_br',
  'ttv_br',
  'refund_ttv',
  'vendor_holdback',
  'gm_adjusted',
  'ttv_adjusted',
  'orders_br',
  'orders_all',
  'customers_br',
  'customers_all',
  'items_br',
  'leadtime_br_total',
  'leadtime_br_known',
  'leadtime_total',
  'leadtime_known',
  'session_order_days_total',
  'session_order_days_known',
  'first_sale_margin',
];

export const salesSummaryFields = ['split_one', 'split_two', ...salesDailyFields.slice(2)];
